import GET_DEVICES_BY_LOCATION_ID from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/posting/getDevicesByLocationId.graphql';
import { useMemo } from 'react';
import { useIsNpssUser } from 'src/auth';
import { useQueryWithBoundary } from 'src/hooks';

export const normalizeDevice = (device: any) => ({
  id: device.id,
  name: device.details.name,
  type: device.details.type,
  isRecordingEnabled: device.settings?.is_recording_enabled,
});

export const defaultDevice = {
  id: 'all-cameras',
  name: 'All Cameras',
  type: '',
  isRecordingEnabled: false,
};

export const useGetDevicesByLocationId = (
  locationId: string | null,
  onCompleted?: () => void,
) => {
  const isNpssUser = useIsNpssUser();

  const { data: unfilteredData, ...rest } = useQueryWithBoundary(
    GET_DEVICES_BY_LOCATION_ID,
    {
      variables: {
        location_id: locationId,
      },
      skip: isNpssUser || !locationId,
      onCompleted,
    },
  );

  const result = useMemo(() => {
    if (unfilteredData) {
      //hack for exluding non videos device (check for existence of the 'is_recording_enabled' prop)
      const data = unfilteredData?.ringDevicesByLocationId?.filter?.(
        (device: any) =>
          device?.settings?.hasOwnProperty?.('is_recording_enabled'),
      );
      return {
        ...rest,
        data: [defaultDevice, ...data.map(normalizeDevice)],
      };
    }

    return {
      data: [defaultDevice],
      ...rest,
    };
  }, [rest, unfilteredData]);

  return result;
};
